import styled from "styled-components";

const SidebarItemMenu2 = styled.li`
  display: flex;
  color: #f3f3f3;
  padding-left: 10%;
  padding-top: 2%;
  padding-bottom: 2%;
  justify-content: space-between;
  cursor: pointer;
`;

export default SidebarItemMenu2;
